import { render, staticRenderFns } from "./QuestionDisplay.vue?vue&type=template&id=4345ef73"
import script from "./QuestionDisplay.vue?vue&type=script&lang=js"
export * from "./QuestionDisplay.vue?vue&type=script&lang=js"
import style0 from "./QuestionDisplay.vue?vue&type=style&index=0&id=4345ef73&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports